import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import PlayIcon from '@mui/icons-material/PlayCircleFilled';
import PauseIcon from '@mui/icons-material/PauseCircleFilled';
import PropTypes from 'prop-types';

UserActions.propTypes = {
  handleValidation: PropTypes.func.isRequired,
  handleBlock: PropTypes.func.isRequired,
  activated: PropTypes.bool,
};

export default function UserActions({ handleValidation, handleBlock, activated }) {
  return (
    <>
      <Tooltip title={activated ? 'Pausar usuário' : 'Ativar usuário'}>
        <IconButton color="inherit" onClick={handleBlock}>
          {activated ? <PauseIcon /> : <PlayIcon />}
        </IconButton>
      </Tooltip>
      <Tooltip title="Salvar">
        <IconButton color="inherit" onClick={handleValidation}>
          <DoneIcon />
        </IconButton>
      </Tooltip>
    </>
  );
}
